// src/questions-data.js

export const questions = [
  // =========================
  // DOG + CAT SHARED QUESTIONS
  // =========================
  {
    id: "walkLocation",
    label: "Location of walk:",
    type: "text",
    activities: ["Walk", "Indoor Activity", "Outdoor Activity"],
    required: false,
    hidden: true,
    systemGenerated: true,
    modes: ["dog", "cat"],
  },
  {
    id: "walkStarted",
    label: "Start time:",
    type: "time",
    activities: ["Walk", "Indoor Activity", "Outdoor Activity"],
    required: true,
    modes: ["dog", "cat"],
  },
  {
    id: "walkDuration",
    label: "Duration: (in minutes)",
    type: "text",
    activities: ["Walk", "Indoor Activity", "Outdoor Activity"],
    required: true,
    modes: ["dog", "cat"],
  },

  // =========================
  // DOG QUESTIONS
  // =========================
  {
    id: "peed",
    label: "Did the dog urinate?",
    type: "select",
    options: ["Yes", "No"],
    activities: ["Walk",  "Outdoor Activity"],
    required: true,
    modes: ["dog"],
  },
  {
    id: "pooped",
    label: "Did the dog defecate?",
    type: "select",
    options: ["No", "Normal stool", "Soft stool", "Diarrhea"],
    activities: ["Walk", "Outdoor Activity"],
    required: true,
    modes: ["dog"],
  },
  {
    id: "snacks",
    label: "How many treats did the dog receive?",
    type: "select",
    options: ["None", "A few", "Many"],
    activities: ["Walk", "Outdoor Activity"],
    required: true,
    modes: ["dog"],
  },
  {
    id: "behaviorChanges",
    label: "Behavioral level?",
    type: "select",
    options: ["Green", "Blue", "Yellow", "Red", "Staff Only"],
    activities: ["Walk", "Indoor Activity", "Outdoor Activity"],
    required: true,
    modes: ["dog", "cat"],
  },
  {
    id: "enrichmentActivities",
    label: "Enrichment activities:",
    type: "multiselect",
    options: [
      "Snuffle mats",
      "Kongs / lick mats",
      "Muffin tin 'find it' game",
      "Bubbles",
      "Story time",
      "Puppy practice",
      "General play (ball, toys, etc.)",
      "Aromatherapy",
      "Brushing",
      "Other",
    ],
    activities: ["Indoor Activity"],
    required: true,
    modes: ["dog"],
  },

  // =========================
  // CAT QUESTIONS
  // =========================
  {
    id: "catLocation",
    label: "Location:",
    type: "text",
    required: false,
    hidden: true,
    systemGenerated: true,
    modes: ["cat"],
  },
      {
    id: "catsActivities",
    label: "Activities:",
    type: "multiselect",
    options: [
      "Brushing",
      "Playing with wand toy",
      "Brought to enrichment room",
      "Sitting with/ quiet time",
      "Other",
    ],
    activities: [],
    required: true,
    modes: ["cat"],
  },
    {
    id: "additionalNotes",
    label: "Additional notes",
    type: "textarea",
    required: false,
    modes: ["dog", "cat"],
  },

];
